const REACT_BASE_ROUTES = {
    Payments: { path: '/payments', pageId: 'PAYMENTS', title: '' },
    Cart: {
        path: '/cart',
        reroutePath: '/cart-r',
        title: 'cart.page.shopping.bag',
        pageId: 'CART',
    },
    Account: { path: '/account', title: 'hub.account.title', pageId: 'ACCOUNT' },
    AccountCos: { path: '/my-account', title: 'hub.account.title', pageId: 'COSACCOUNT' },
    Checkout: {
        path: '/checkout',
        reroutePath: '/checkout-r',
        title: 'checkout.page.title',
        pageId: 'MULTISTEP CHECKOUT SUMMARY',
    },
    Favourites: { path: '/favourites', title: 'favorites.page.wishlist', pageId: 'FAVOURITES' },
    LinkAccounts: {
        path: '/styleid/linkaccount',
        title: 'Link Account',
        pageId: 'LINK ACCOUNT',
    },
    PublicProfile: {
        path: '/profile',
        title: 'stylehub.profile.view.title',
        pageId: 'PROFILE',
    },
    Styleboard: {
        path: '/styleboard/:styleboardId',
        title: 'styleboard.page.title',
        pageId: 'STYLEBOARD',
    },
    StyleboardLanding: {
        path: '/styleboard',
        title: 'styleboard.landingpage.view.all.styleboards',
        pageId: 'STYLEBOARD LANDING',
    },
    StyleStories: {
        path: '/stylestory',
        title: 'stylestory.page.title',
        pageId: 'STYLESTORY',
    },
    StyleTest: {
        path: '/styletest',
        title: 'Style Test',
        pageId: 'STYLETEST',
    },
    Register: { path: '/register', title: 'hub.register.title', pageId: 'REGISTER' },
    Login: { path: '/login', title: 'j_username', pageId: 'LOGIN' },
    LoginCheckout: {
        path: '/login/checkout',
        title: 'checkout.login.page.title',
        pageId: 'CHECKOUT : LOGIN',
    },
    DigitalStylistEditorialPage: {
        path: '/digital-stylist-editorial',
        pageId: 'DIGITAL STYLIST EDITORIAL',
        title: 'Style Corner Editorial',
    },
    StoreLocator: {
        path: '/:customerService/:customerServicePage/:storeLocator',
        pageId: 'STORE LOCATOR',
        title: '',
    },
    Returns: {
        path: '/returns',
        title: 'Returns',
        pageId: 'RETURNS',
    },
    UnreviewedProducts: {
        path: '/account/unreviewedproducts',
        title: 'profile.unreviewedproducts.review.page.reviews',
        pageId: 'UNREVIEWEDPRODUCTS',
    },
    UnreviewedProductsOtherStories: {
        path: '/my-account/unreviewedproducts',
        title: 'profile.unreviewedproducts.review.page.reviews',
        pageId: 'UNREVIEWEDPRODUCTS',
    },
    UnreviewedProductsArket: {
        path: '/my-account/unreviewedproducts',
        title: 'profile.unreviewedproducts.review.page.reviews',
        pageId: 'UNREVIEWEDPRODUCTS',
    },
    UnreviewedProductsCos: {
        path: '/my-account/unreviewedproducts',
        title: 'profile.unreviewedproducts.review.page.reviews',
        pageId: 'UNREVIEWEDPRODUCTS',
    },
    UnreviewedProductsMonki: {
        path: '/my-account/unreviewedproducts',
        title: 'profile.unreviewedproducts.review.page.reviews',
        pageId: 'UNREVIEWEDPRODUCTS',
    },
};
export default REACT_BASE_ROUTES;
//# sourceMappingURL=reactBaseRoutes.js.map